<script>
import RosterActualView from "./RosterActualView.vue";

export default {
  name: "RosterAiActualView",
  extends: RosterActualView,
  computed: {
    isActualRoster() {
      return true;
    },
    isAiRoster() {
      return false;
    },
    pageSectionLabel() {
      return "Manage AI Actual Roster";
    },
    rosterIndexPath() {
      return "/roster/ai/actual/index";
    },
    rosterViewPath() {
      return "/roster/ai/actual/view";
    },
    rosterListEndpoint() {
      return "/roster/aiactualindex";
    },
    monthlyEndpoint() {
      return "/roster/monthly";
    },
    rosterViewEndpoint() {
      return "/roster/view";
    },
    viewPageLabel() {
      return "View AI Actual roster";
    },
    createPageLabel() {
      return "Create AI Actual roster";
    },
  },
};
</script>
